import { ShieldOff } from "lucide-react";

const items = [
  "We won't remove honest negative reviews",
  "We won't write or pay for fake reviews",
  "We won't promise removals we can't deliver",
  "We won't break Amazon's rules",
];

export function EthicsStrip() {
  return (
    <section className="bg-slate-900 text-white dark:bg-slate-950 dark:border-y dark:border-slate-800">
      <div className="max-w-6xl mx-auto px-6 py-16">
        <div className="flex items-start gap-4">
          <ShieldOff className="h-6 w-6 text-emerald-400 shrink-0 mt-1" />
          <div>
            <h2 className="text-2xl md:text-3xl font-semibold tracking-tight">
              What we won&rsquo;t do
            </h2>
            <p className="mt-2 text-slate-400 dark:text-slate-400">
              There&rsquo;s a line between defending your reputation honestly
              and gaming the system. We don&rsquo;t cross it.
            </p>
            <ul className="mt-6 grid sm:grid-cols-2 gap-3 text-sm">
              {items.map((i) => (
                <li key={i} className="text-slate-300 dark:text-slate-300">
                  — {i}
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
}
